import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import LazyAudioPlayer from "../components/baseComponents/lazyAudioPlayer";
import CallLogResponse from "../interfaces/callLogResponse";

const callLogColumnDef: GridColDef[] = [
    { field: 'call_log_id', headerName: 'Call Log ID', width: 150 },
    { field: 'client_reference_id', headerName: 'Client Reference ID', width: 220 },
    { field: 'client_name', headerName: 'Client Name', width: 150 },
    { field: 'callee_did', headerName: 'Callee Number', width: 140 },
    { field: 'caller_did', headerName: 'Caller Number', width: 140 },
    { field: 'caller', headerName: 'Caller', width: 150 },
    { field: 'call_type', headerName: 'Call Type', width: 100 },
    { field: 'call_result', headerName: 'Call Result', width: 130 },
    { field: 'duration', headerName: 'Duration (sec)', width: 120 },
    { field: 'start_time_of_call', headerName: 'Start Time', width: 180 },
    { field: 'end_time_of_call', headerName: 'End Time', width: 180 },
    { field: 'agency_name', headerName: 'Agency', width: 150 },
    { field: 'created_date', headerName: 'Created Date', width: 180 },
    // Fields from call_log_report
    { field: 'user_conversation_classification', headerName: 'User Classification', width: 180},
    { field: 'agent_conversation_classification', headerName: 'Agent Classification', width: 180},
    // Fields from interaction_history
    { field: 'interaction_type', headerName: 'Interaction Type', width: 150},
    { field: 'disposition_order', headerName: 'Disposition Order', width: 180},
    { field: 'ptp_date', headerName: 'PTP Date', width: 150},
    {
        field: 'call_recording_storage_key',
        headerName: 'Recording',
        width: 300,
        sortable: false,
        filterable: false,
        renderCell: (params: GridRenderCellParams<CallLogResponse>) => {
            if (params.row.call_recording_storage_key) {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <LazyAudioPlayer src={params.row.call_recording_storage_key} height={45} />
                    </Box>
                );
            }
            return 'N/A';
        }
    }
];

export default callLogColumnDef;
